import AppState from "../types/AppState";

export default function createAppState(): AppState {
    return {}
}